










































import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { MetaService } from '@/shared/services/meta-service'
import { Hooks } from '@/shared/interfaces/hooks'
import { DataSource } from '@/shared/models/data/data-source'
import { OrganisationResponse } from '@/api/generated'
import { DataSourcePaginator } from '@/shared/models/data/data-source-paginator'
import { OrganisationActivityDataSource } from '@/business/organisation/organisation-activity-data-source'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import OrganisationActivity from '@/business/organisation/components/organisation-activity.vue'
import { OrganisationActivity as Activity } from '@/api/generated'

@Component({
  name: 'organisation-activities',
  components: {
    OrganisationActivity,
    RespondecoLoadingIndicator,
    UnifyButton,
    RespondecoResponsiveImage,
  },
})
export default class OrganisationActivities extends Vue implements Hooks {
  private dataSource!: DataSource<Activity>
  private paginator!: DataSourcePaginator<Activity>

  private metaService = Injector.get(MetaService)
  private organisationModule = Injector.get(OrganisationsModule)

  public get activities(): Activity[] {
    return this.paginator.items
  }

  public get hasMore(): boolean {
    return this.paginator.items.length < this.paginator.total
  }

  public get isInitializing(): boolean {
    return this.paginator.isInitializing()
  }

  public get isLoading(): boolean {
    return this.paginator.isSearching()
  }

  public get organisation(): OrganisationResponse {
    return this.organisationModule.organisationViewModel.organisation
  }

  constructor() {
    super()

    this.dataSource = new OrganisationActivityDataSource()
    this.paginator = new DataSourcePaginator(this.dataSource)
  }

  public mounted() {
    this.metaService.updateDocumentTitle('organisation.activities', {
      name: this.organisation.name,
    })

    this.paginator.initialize()
  }

  public loadMore() {
    this.paginator.next().update()
  }
}
